import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog, Box, OutlinedInput, Typography, Stack, Switch } from "@mui/material";
import { alpha } from "@mui/material/styles";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import notifier from "../Notifier";
import {
  checkExtension,
  getErrorString,
  getUserDetail,
  isEmpty,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import { Upload } from "react-iconly";
import Loader from "../Loader";
import { capitalize } from "lodash";
import ConfirmPlayListNft from "../ConfirmPlaylistNft";
import { Images } from "../../assets/common";
import DoneIcon from "@mui/icons-material/Done";
import "./index.scss";
import { Formik } from "formik";
import * as yup from "yup";
import { UserContext } from "../../context/userContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddPopup(props) {
  const { t } = useTranslation("common");
  const [form, setForm] = React.useState({});
  const [confirm, setConfirm] = React.useState(false);
  const [image, setImage] = React.useState(null);
  const [file, setFile] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [explicit, setExplicit] = React.useState(null);
  const schema = yup.object().shape({
    isExplicit: yup.boolean(),
  });
  const userData = getUserDetail();

  const [name, setName] = React.useState(
    props["data"] ? props["data"]["title"] : ""
  );
  const [description, setDescription] = React.useState("");
  // Playlist only: subscribers-only studio, sent as `private`.
  const [privateStudio, setPrivateStudio] = React.useState(false);
  const save = async (values) => {
    const imgsize = file.size / 1024;
    if (imgsize > 6144) {
      notifier.error(t("notifier.error.toast12"));
      return;
    }
    if (typeof explicit !== "boolean") {
      notifier.error("The Explicit field is mandatory");
      return;
    }
    // console.log(values, "VAlues ::::::::");
    try {
      setLoading(true);
      const formData = new FormData();

      let response;
      if (props.api === "playlist") {
        handleOpenConfirm({
          title: name,
          file: file,
          isExplicit: values.isExplicit,
          description: description,
          private: privateStudio,
        });
        return;
      } else {
        formData.append("title", name);
        formData.append("thumbnailImg", file);
        formData.append("isExplicit", explicit);
        // if (!props["data"])
        //   formData.append(
        //     checkExtension(file["name"])[0] === "gif" ? "GIF" : "thumbnail",
        //     file
        //   );
        response = props["data"]
          ? await ApiService.EDIT_ALBUM(formData, props["data"]["_id"])
          : await ApiService.CREATE_ALBUM(formData);
        setLoading(false);
        notifier.success(
          props["data"]
            ? t("notifier.success.toast17")
            : t("notifier.success.toast18")
        );
        props.handleClose(
          response["result"],
          false,
          props["data"] ? name : null
        );
      }
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const update = async () => {
    try {
      const imgsize = file.size / 1024;
      if (imgsize > 6144) {
        notifier.error(t("notifier.error.toast12"));
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("GIF", file);
      formData.append("isExplicit", explicit);
      const response = await ApiService.EDIT_PLAYLIST(props["id"], formData);

      setLoading(false);
      notifier.success(t("notifier.success.toast16"));
      props.handleClose(
        props["selectedIndex"],
        false,
        response["result"]["GIF"],
        response["result"]["isExplicit"]
      );
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const handleOpenConfirm = (formData) => {
    setForm({ ...formData });
    setConfirm(true);
    setLoading(false);
  };
  const addNftPlaylist = (e, close) => {
    // Always close the confirm modal first
    setConfirm(false);

    if (e) {
      // If successful, reset state and close parent
      setImage(null);
      setFile({});
      setName("");
      setDescription("");
      setExplicit(null);
      props.handleClose(e, close);
    }
  };
  function onFileChooser(id) {
    document.getElementById(id).click();
  }

  const onFileSelect = async (e, type) => {
    imageHandler(e.target.files[0], type);
  };

  async function imageHandler(e, type) {
    const reader = new FileReader();
    reader.onload = async function () {
      if (reader.readyState === 2) {
        if (type === "thumbnail") {
          setFile(e);
          setImage(reader.result);
        }
      }
    };
    reader.readAsDataURL(e);
  }

  React.useEffect(() => {
    if (props.open) {
      // Reset state when dialog opens
      setImage(props["image"] ? props["image"] : null);
      setExplicit(
        props["data"] ? props["data"]["isExplicit"] : props["isExplicit"]
      );
      setName(props["data"] ? props["data"]["title"] : "");
      setDescription("");
      setFile({});
    }
  }, [props.open]);

  let year = userData && userData["birthYear"] ? new Date().getFullYear() - userData["birthYear"] : 25; // Default to 25 if no user data (assume adult)

  return (
    <div>
      <Dialog
        open={props.open}
        fullWidth
        maxWidth="xs"
        TransitionComponent={Transition}
        onClose={(event, reason) => {
          // Don't close on backdrop click, only allow escape key or button clicks
          if (reason !== 'backdropClick') {
            // Reset state when closing
            setImage(null);
            setFile({});
            setName("");
            setDescription("");
            setExplicit(null);
            props.handleClose(null, false);
          }
        }}
        PaperProps={{
          sx: (theme) => ({
            boxShadow: "none",
            color: theme.palette.text.primary,
            borderRadius: "16px",
            margin: 0,
            backgroundColor: theme.palette.background.paper,
          }),
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <Stack sx={{ padding: "16px" }} spacing={1}>
            <Stack spacing={1}>
              <Typography className="fs-16" color="text.primary">
                {props.title}
              </Typography>
              {props["selectedIndex"] >= 0 ? null : (
                <DialogContent sx={{ padding: 0 }}>
                  <OutlinedInput
                    sx={{
                      width: "100%",
                      backgroundColor: (theme) =>
                        theme.custom?.accent?.main ||
                        theme.palette.background.default,
                      height: "50px",
                      borderRadius: "16px",
                      color: (theme) => theme.palette.text.primary,
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: (theme) =>
                          alpha(theme.palette.text.primary, 0.2),
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: (theme) =>
                          alpha(theme.palette.text.primary, 0.35),
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: (theme) => theme.palette.primary.main,
                      },
                    }}
                    autoFocus
                    margin="dense"
                    id="name"
                    placeholder={`${t("enter")} ${capitalize(
                      props.api === "playlist"
                        ? t("confirmPopup.text2")
                        : t("confirmPopup.text4")
                    )} ${t("name")}`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoComplete="off"
                  />
                </DialogContent>
              )}
              {/* Description field for playlists */}
              {props["selectedIndex"] == null && props.api === "playlist" && (
                <DialogContent sx={{ padding: 0 }}>
                  <OutlinedInput
                    sx={{
                      width: "100%",
                      backgroundColor: (theme) =>
                        theme.custom?.accent?.main ||
                        theme.palette.background.default,
                      borderRadius: "16px",
                      color: (theme) => theme.palette.text.primary,
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: (theme) =>
                          alpha(theme.palette.text.primary, 0.2),
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: (theme) =>
                          alpha(theme.palette.text.primary, 0.35),
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: (theme) => theme.palette.primary.main,
                      },
                    }}
                    multiline
                    rows={3}
                    margin="dense"
                    placeholder="Description (optional)"
                    value={description}
                    onChange={(e) => {
                      if (e.target.value.length <= 200) setDescription(e.target.value);
                    }}
                    inputProps={{ maxLength: 200 }}
                    autoComplete="off"
                  />
                  <Typography
                    sx={{
                      textAlign: "right",
                      fontSize: "11px",
                      color: (theme) =>
                        description.length >= 200
                          ? "#f44336"
                          : theme.palette.text.secondary,
                      opacity: 0.6,
                      mt: 0.5,
                      mr: 1,
                    }}
                  >
                    {description.length}/200
                  </Typography>
                  {props.api === "playlist" && (
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                      <Stack>
                        <Typography className="fs-14" color="text.primary">Subscribers only</Typography>
                        <Typography sx={{ fontSize: "11px", opacity: 0.6 }} color="text.primary">
                          Only your subscribers can open it; everyone still sees it on your profile.
                        </Typography>
                      </Stack>
                      <Switch checked={privateStudio} onChange={(e) => setPrivateStudio(e.target.checked)} />
                    </Stack>
                  )}
                </DialogContent>
              )}
            </Stack>
            {/* {props["selectedIndex"] >= 0 || props.api === "playlist" ? ( */}
            <Stack spacing={0} >
              <Typography className="fs-14" color="text.primary">
                {props.api === "album"
                  ? t("addPopup.placeholder2")
                  : t("addPopup.placeholder1")}
              </Typography>
              <Box
                onClick={() => onFileChooser("thumbnail")}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: (theme) =>
                    theme.custom?.accent?.main ||
                    alpha(theme.palette.text.primary, 0.04),
                  borderRadius: "25px",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: { xs: 280, sm: 320 },
                  height: { xs: 180, sm: 240 },
                  mx: "auto",
                  border: (theme) =>
                    `1px dashed ${alpha(theme.palette.text.primary, 0.2)}`,
                  cursor: "pointer",
                  px: 2,
                }}
              >
                <Stack
                  direction="row"
                  sx={{
                    width: "100%",
                    height: "100%",
                    gap: "10px",
                    textAlign: "center",
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  {image ? (
                    <img
                      className="__selectedImg"
                      src={image}
                      alt={props["api"]}
                    />
                  ) : (
                    <Stack
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                      sx={{ width: "100%" }}
                    >
                      <Box
                        component="img"
                        src={Images.upload}
                        alt=""
                        sx={{
                          width: 64,
                          height: 64,
                          objectFit: "contain",
                          opacity: 0.8,
                        }}
                      />
                      <Typography
                        className="fs-13 __tap_select"
                        color="text.secondary"
                        textAlign="center"
                      >
                        {t("addPopup.placeholder3")}
                      </Typography>
                    </Stack>
                  )}
                </Stack>

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="thumbnail"
                  onChange={(e) => onFileSelect(e, "thumbnail")}
                  required
                />
              </Box>
            </Stack>
            <Stack direction="column" sx={{ marginTop: "10px" }}>
              <Formik
                validationSchema={schema}
                onSubmit={(Values) => {
                  save(Values);
                }}
                initialValues={{ isExplicit: explicit }}
              >
                {({ handleSubmit, values, setFieldValue }) => (
                  <Stack onSubmit={handleSubmit}>
                    {" "}
                    <Typography variant="body1" color="text.primary">
                      {t("addPopup.explicit")}
                    </Typography>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={2}
                      sx={{ width: "100%" }}
                    >
                      <Button
                        onClick={() => {
                          setFieldValue("isExplicit", true);
                          setExplicit(true);
                        }}
                        onChange={() => setExplicit(true)}
                        color="primary"
                        variant={
                          values.isExplicit === true ? "contained" : "outlined"
                        }
                        sx={(theme) => ({
                          flex: 1,
                          minWidth: 140,
                          borderRadius: "24px",
                          px: 3,
                          py: 1.5,
                          justifyContent: "center",
                          ...(values.isExplicit === true
                            ? {
                                color: theme.palette.primary.contrastText,
                              }
                            : {
                                color: theme.palette.text.primary,
                                borderColor: alpha(
                                  theme.palette.text.primary,
                                  0.25
                                ),
                              }),
                        })}
                        startIcon={
                          values.isExplicit === true ? (
                            <DoneIcon
                              sx={{
                                backgroundColor: (theme) =>
                                  theme.palette.primary.contrastText,
                                borderRadius: "50%",
                                fontSize: "14px !important",
                                padding: "2px",
                                color: (theme) => theme.palette.primary.main,
                              }}
                            />
                          ) : null
                        }
                        disabled={year < 18}
                      >
                        {t("addPopup.yes")}
                      </Button>
                      {year < 18 ? (
                        <Button
                          color="primary"
                          variant={
                            values.isExplicit === false
                              ? "contained"
                              : "outlined"
                          }
                          sx={(theme) => ({
                            flex: 1,
                            minWidth: 140,
                            borderRadius: "24px",
                            px: 3,
                            py: 1.5,
                            justifyContent: "center",
                            ...(values.isExplicit === false
                              ? {
                                  color: theme.palette.primary.contrastText,
                                }
                              : {
                                  color: theme.palette.text.primary,
                                  borderColor: alpha(
                                    theme.palette.text.primary,
                                    0.25
                                  ),
                                }),
                          })}
                          defaultValue={setExplicit(false)}
                          startIcon={
                            <DoneIcon
                              sx={{
                                backgroundColor: (theme) =>
                                  theme.palette.primary.contrastText,
                                borderRadius: "50%",
                                fontSize: "14px !important",
                                padding: "2px",
                                color: (theme) => theme.palette.primary.main,
                              }}
                            />
                          }
                        >
                          {t("addPopup.no")}
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            setFieldValue("isExplicit", false);
                            setExplicit(false);
                          }}
                          onChange={() => setExplicit(false)}
                          color="primary"
                          variant={
                            values.isExplicit === false
                              ? "contained"
                              : "outlined"
                          }
                          sx={(theme) => ({
                            flex: 1,
                            minWidth: 140,
                            borderRadius: "24px",
                            px: 3,
                            py: 1.5,
                            justifyContent: "center",
                            ...(values.isExplicit === false
                              ? {
                                  color: theme.palette.primary.contrastText,
                                }
                              : {
                                  color: theme.palette.text.primary,
                                  borderColor: alpha(
                                    theme.palette.text.primary,
                                    0.25
                                  ),
                                }),
                          })}
                        startIcon={
                          values.isExplicit === false ? (
                            <DoneIcon
                              sx={{
                                backgroundColor: (theme) =>
                                  theme.palette.primary.contrastText,
                                borderRadius: "50%",
                                fontSize: "14px !important",
                                padding: "2px",
                                color: (theme) => theme.palette.primary.main,
                              }}
                            />
                          ) : null
                        }
                        >
                          {t("addPopup.no")}
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                )}
              </Formik>
            </Stack>
            {/* ) : null} */}
            <DialogActions
              sx={{
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
                pt: 3,
              }}
            >
              <Button
                sx={(theme) => ({
                  flex: 1,
                  minWidth: 120,
                  maxWidth: 180,
                  padding: "10px 24px",
                  color: theme.palette.text.secondary,
                })}
                onClick={() => {
                  // Reset state when canceling
                  setImage(null);
                  setFile({});
                  setName("");
                  setDescription("");
                  setExplicit(null);
                  props.handleClose(null, false);
                }}
              >
                {t("addPopup.cancel")}
              </Button>
              {props["selectedIndex"] >= 0 ? (
                <Button
                  sx={{
                    flex: 1,
                    minWidth: 120,
                    maxWidth: 180,
                    padding: "10px 24px",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={update}
                  disabled={!file["name"] && explicit === undefined}
                >
                  {t("addPopup.update")}
                </Button>
              ) : (
                <Button
                  sx={{
                    flex: 1,
                    minWidth: 120,
                    maxWidth: 180,
                    padding: "10px 24px",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={save}
                  // disabled={!file["name"]}
                  disabled={
                      props?.editAlbum && props["api"] === "album" 
                      ? !name && !file["name"] && explicit == null 
                      : props["api"] === "album"
                      ? !name || !file["name"] || explicit == null
                      : props["api"] === "playlist"
                      ? !name || !file["name"] || !explicit == null
                      : false
                  }
                >
                  {props.api === "playlist"
                    ? t("addPopup.create")
                    : t("addPopup.save")}
                </Button>
              )}
            </DialogActions>
          </Stack>
        </Stack>
      </Dialog>
      {loading ? <Loader /> : null}
      {confirm ? (
        <ConfirmPlayListNft
          data={explicit}
          open={confirm}
          form={form}
          handleClose={(e, close) => addNftPlaylist(e, close)}
        />
      ) : null}
    </div>
  );
}
